export const path = {
  methods: {
    getInternalPath(path) {
      return path
    }
  }
}
